import { Card } from 'antd';
import { twoFactorPinCodeValidationSchema } from 'common/config/validationSchema';
import { MfaCodeForm } from 'common/organisms/MfaCodeForm';
import { Formik } from 'formik';
import * as React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { usernameSelector } from 'state/auth/auth.selectors';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { FormattedMessage } from 'react-intl';
import { WrappedLanguageControl } from 'common/organisms/WrappedLanguageControl';
import { PublicContainer } from 'common/components/PublicContainer';

const StyledCard = styled(Card)`
  max-width: 350px;

  form {
    margin-top: 1rem;
  }
`;
export interface TwoFactorPinCodeAuthTemplateProps {
  loading: boolean;
  onSubmit: (payload: {
    username: string;
    mfaVerificationCode: string;
  }) => void;
}

export const MfaLoginTemplate: React.FC<TwoFactorPinCodeAuthTemplateProps> = ({
  loading,
  onSubmit,
}) => {
  const username = useSelector(usernameSelector);
  const intlMessage = useFormatMessage();

  return (
    <PublicContainer>
      <WrappedLanguageControl />
      <StyledCard title={intlMessage({ id: 'mfa' })}>
        <FormattedMessage id="mfa.enterCode" tagName="p" />
        <Formik
          initialValues={{ mfaVerificationCode: '' }}
          onSubmit={(values) =>
            onSubmit({ ...values, username: username as string })
          }
          validationSchema={twoFactorPinCodeValidationSchema(intlMessage)}
        >
          {(formikProps) => <MfaCodeForm loading={loading} />}
        </Formik>
      </StyledCard>
    </PublicContainer>
  );
};
